import { useT } from '../../i18n/useT'

export function HowItWorksSection() {
  const t = useT()
  const steps = [
    { title: t('how.step1.title'), text: t('how.step1.text') },
    { title: t('how.step2.title'), text: t('how.step2.text') },
    { title: t('how.step3.title'), text: t('how.step3.text') },
  ]
  return (
    <section id="how-it-works" className="py-16 bg-surface-alt scroll-mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl font-bold text-text text-center">{t('how.title')}</h2>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="bg-surface border border-border rounded-2xl p-6">
              <div className="w-10 h-10 rounded-full bg-primary text-on-accent flex items-center justify-center text-base font-semibold">
                {i + 1}
              </div>
              <h3 className="mt-4 text-base font-semibold text-text">{step.title}</h3>
              <p className="mt-1.5 text-sm text-text-secondary leading-relaxed">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
